export const HEADER_ZINDEX = 10000;
export const FOOTER_ZINDEX = 10000;
export const MODAL_ZINDEX = 20000;
export const LOADINGSPINNER_ZINDEX = 30000;
